import { jsxs as m, jsx as e, Fragment as u } from "react/jsx-runtime";
import { Paragraph as c } from "../../atoms/Paragraph/Paragraph.es.js";
import { useMultiStyleConfig as x, Divider as C } from "@chakra-ui/react";
import "../../icons/index.es.js";
import "../../atoms/Button/Button.es.js";
import "../Dropdown/Dropdown.context.es.js";
import { DropdownContent as g } from "../Dropdown/components/DropdownContent.es.js";
import { DropdownItem as y } from "../Dropdown/components/DropdownItem.es.js";
import "../Dropdown/Dropdown.container.es.js";
import "./components/AutocompleteInput.es.js";
import { AutocompleteOptions as S } from "./components/AutocompleteOptions.es.js";
import { AutocompleteActions as v } from "./components/AutocompleteActions.es.js";
const P = ({
  children: p,
  customActions: r = [],
  emptyStatePlaceholder: l = "No results",
  isLoading: i,
  onClear: a,
  onClickOption: d,
  options: t = [],
  query: s = ""
}) => {
  const f = (t == null ? void 0 : t.length) > 0, n = (r == null ? void 0 : r.length) > 0, o = x("Autocomplete");
  return i ? null : /* @__PURE__ */ m(
    g,
    {
      contentStyles: {
        ...o.dropdownContent
      },
      returnFocus: !1,
      children: [
        f ? /* @__PURE__ */ e(
          S,
          {
            options: t,
            onClickOption: (h) => d(h, a),
            query: s
          }
        ) : /* @__PURE__ */ m(u, { children: [
          /* @__PURE__ */ e(y, { as: "div", tabIndex: void 0, sx: o.emptyStateContainer, children: /* @__PURE__ */ e(c, { as: "span", size: "md", sx: o.emptyStateText, children: l }) }),
          n && /* @__PURE__ */ e(C, {})
        ] }),
        n ? /* @__PURE__ */ e(v, { customActions: r, options: t }) : null,
        p
      ]
    }
  );
};
export {
  P as AutocompleteComponent
};
//# sourceMappingURL=Autocomplete.component.es.js.map
